import { useCallback } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';

import OptionGroup from '#client/components/OptionGroup';
import { getChoices } from '#client/pages/BusinessStage/BusinessStage';

const FIELD_NAME = 'businessStage';

function BusinessStageFieldset() {
  const { control, setValue } = useFormContext();
  const { formatMessage } = useIntl();

  const value = useWatch({
    control,
    name: FIELD_NAME
  });

  const handleChange = useCallback(
    (newValue) => {
      setValue(FIELD_NAME, newValue);
    },
    [setValue]
  );

  return (
    <OptionGroup
      name={FIELD_NAME}
      options={getChoices(formatMessage)}
      value={value}
      onChange={handleChange}
    />
  );
}

export default BusinessStageFieldset;
